import React from 'react';
import PropTypes from 'prop-types';
import profileImage from '../../images/profile_bike.jpg';

const AboutImg = ({ filename, alt }) => {
  if (filename !== 'profile_bike.jpg') return null;

  return <img className="rounded shadow-lg img-fluid" src={profileImage} alt={alt} />;
};

AboutImg.propTypes = {
  filename: PropTypes.string,
  alt: PropTypes.string,
};

export default AboutImg;
